export const FETCH_POSTS = 'FETC_POSTS';
export const NEW_POST = 'NEW_POST';
export const LANGUAGE = 'LANGUAGE';
export const FETCH_SOURCES = 'FETCH_SOURCES';
export const SCREEN_NUMBER = 'SCREEN_NUMBER';
export const SCORE = 'SCORE';
export const PLAYTIME = 'PLAYTIME';
export const FETCH_MYTHSANDFACTS = 'FETCH_MYTHSANDFACTS';
export const FETCH_GAMECUSTOMCONFIG = 'FETCH_GAMECUSTOMCONFIG';
export const RANDAMIZE = 'RANDAMIZE';
export const SETMYTHSANDFACTS = 'SETMYTHSANDFACTS';
export const SETCURRENTINDEX = 'SETCURRENTINDEX';
export const SETCURRENTQUESTION = 'SETCURRENTQUESTION';
export const SETSHOWCORRECTWRONG = 'SETSHOWCORRECTWRONG';


// WEBPACK FOOTER //
// ./src/actions/typs.js